import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { ImageWithFallback } from './ImageWithFallback';
import Slider from 'react-slick';
import slider1 from "../../assets/img/HomePage/slider/slider1.jpeg";
import slider2 from "../../assets/img/HomePage/slider/slider2.jpeg";
import slider3 from "../../assets/img/HomePage/slider/slider3.jpeg";
import slider4 from "../../assets/img/HomePage/slider/slider4.jpeg";
import slider5 from "../../assets/img/HomePage/slider/slider5.jpeg";
import slider6 from "../../assets/img/HomePage/slider/slider6.jpeg";
import slider7 from "../../assets/img/HomePage/slider/slider7.jpeg";
import slider8 from "../../assets/img/HomePage/slider/slider8.jpeg";
import slider9 from "../../assets/img/HomePage/slider/slider9.jpeg";


const SliderComponent = () => {
    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 2000,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        pauseOnHover: false,
        dotsClass: "slick-dots custom-dots",
    };

    const backgroundImages = [
        slider9,
        slider1,
        slider2,
        slider3,
        slider4,
        slider5,
        slider6,
        slider7,
        slider8,
    ];

    return (
        <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden pb-12 mt-205">
            {/* Background Slider */}
            <div className="absolute inset-0 z-10">
                <Slider {...sliderSettings} className="h-full w-full object-cover relative z-0">
                    {backgroundImages.map((img, index) => (
                        <div key={index} className="h-screen w-full outline-none">
                            <ImageWithFallback
                                src={img}
                                alt={`Background ${index + 1}`}
                                className="w-full h-180 object-fill rounded-md"
                                // style={{ objectFit: "contain" }}
                            />
                        </div>
                    ))}
                </Slider>
            </div>
        </section>
    );
};
export default SliderComponent; 